<template>
  <div v-if="currentItem" class="w-full">
    <!-- progresso -->
    <div class="text-sm font-semibold text-gray-500 text-end -mt-2">
      <small>
        {{ currentIndex + 1 }} de {{ checklist.length }} itens
      </small> 
    </div>

    <Transition mode="out-in">
      <div :key="currentIndex">
        <h3 class="mb-4 font-semibold text-gray-900">
          {{ currentItem.title }}
        </h3>
  
        <ul class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex">
          <li
            v-for="(option, index) in currentItem.options"
            :key="index"
            class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r"
          >
            <div class="flex items-center ps-3">
              <input
                type="radio"
                :id="'option-' + currentIndex + '-' + index"
                :value="option"
                name="list-radio"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                v-model="selectedAnswer"
              />
              <label
                :for="'option-' + currentIndex + '-' + index"
                class="w-full py-3 ms-2 text-sm font-medium text-gray-900"
              >
                {{ option }}
              </label>
            </div>
          </li>
        </ul>
      </div>
    </Transition>

    <!-- navegação -->
    <div class="flex justify-between mt-4">
      <button
        v-if="currentIndex > 0"
        @click="prevQuestion"
        class="px-1 py-1 text-gray-500 flex"
      >
        <component class="h-4 w-4 mt-auto mb-auto mx-1" :is="PhArrowLeft"/> 
        Anterior
      </button>

      <button
        v-if="currentIndex < checklist.length - 1"
        @click="nextQuestion"
        class="px-1 py-1 text-blue-500 flex"
      >
        Próxima
        <component class="h-4 w-4 mt-auto mb-auto mx-1" :is="PhArrowRight"/> 
      </button>
    </div>
  </div>
</template>

<script setup>
import { PhArrowRight, PhArrowLeft } from "@phosphor-icons/vue";
import { showToast as toast } from "@/helpers/UseToasts";
import { dataExtinguisher } from "../../../store";
import { ref, computed, watch } from "vue";

const props = defineProps({
  checklist: Array,
});

const store = dataExtinguisher.state;
const currentIndex = ref(0);
const selectedAnswer = ref("");

const currentItem = computed(() => props.checklist[currentIndex.value]);

watch(currentIndex, () => {
  selectedAnswer.value = store.maintenanceForm.checklist[currentIndex.value]?.answer || "";
});

const saveAnswer = () => {
  if (!store.maintenanceForm.checklist) {
    store.maintenanceForm.checklist = [];
  }

  store.maintenanceForm.checklist[currentIndex.value] = {
    question: currentItem.value.title,
    answer: selectedAnswer.value,
  };
};

const nextQuestion = () => {
  if (selectedAnswer.value) {
    saveAnswer();
    if (currentIndex.value < props.checklist.length - 1) {
      currentIndex.value++;
    }
  } else {
    toast(
      'Por favor',
      'Selecione uma opção antes de avançar.',
      'info',
    )
  }
};

const prevQuestion = () => {
  if (currentIndex.value > 0) {
    saveAnswer();
    currentIndex.value--;
  }
};
</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
